/* eslint-disable quotes */
import React from 'react';
import _ from 'lodash';
import Order from '../Order';
import { useAppSelector } from '../../redux/hook';

export default function PastOrders() {
  const { orders, pastOrders, canceledOrders } = useAppSelector(
    (state) => state.orderReducer
  );

  const displayOrders = _.orderBy(
    [..._.values(pastOrders ?? {}), ..._.values(canceledOrders ?? {})],
    (order: any) => new Date(order.date).getTime(),
    ['desc']
  );

  return _.isEmpty(displayOrders) ? (
    <div className='text-center'>
      <p className='text-secondary mb-0 label'>
        {_.isEmpty(orders)
          ? "Vous n'avez encore jamais passé de commande."
          : "Vous n'avez pas encore de commande finalisée."}
      </p>
    </div>
  ) : (
    <div>
      {_.map(displayOrders, (order) => {
        return (
          <Order
            order={order}
            key={order.chargeId}
            showFees
            showPromo
          />
        );
      })}
    </div>
  );
}
